import React, { useContext, useEffect } from "react"
import styled from "styled-components"
import { rem } from "polished"
import { graphql } from "gatsby"
import { Row, Col } from "react-flexbox-grid"

import { UserContext } from "../components/global-context"

import LogoSpacer from "../components/logo-spacer"
import Container from "../components/container"

import WorkItem from "../components/work-page/single-item"

const El = styled.div``

const StyledRow = styled(Row)`
  align-self: center;
  display: flex;
  align-items: center;
`

const WorkItemContainer = styled.div`
  position: relative;
  z-index: 1;

  &:first-of-type {
    @media ${props => props.theme.mobileUp} {
      margin-top: ${rem(150)};
    }

    @media ${props => props.theme.mobileDown} {
      margin-top: ${rem(80)};
    }
  }

  &:not(:first-of-type) {
    margin-top: ${rem(150)};

    @media ${props => props.theme.mobileDown} {
      margin-top: ${rem(50)};
    }
  }

  &:last-of-type {
    margin-bottom: ${rem(200)};

    @media ${props => props.theme.mobileDown} {
      margin-bottom: ${rem(100)};
    }
  }
`

const WorkPage = props => {
  const globalContext = useContext(UserContext)

  const projects = props.data.allWpPost.edges.map(item => ({
    slug: item.node.slug,
    layoutType: item.node.portfolio_item.previewGallery.layoutKind,
    photos: item.node.portfolio_item.previewGallery.images,
  }))

  useEffect(() => {
    globalContext.setValue("#c6c5c6")
  }, [globalContext])

  return (
    <El>
      <LogoSpacer />

      <Container>
        <StyledRow>
          <Col lg={8} md={10} mdOffset={1} lgOffset={2}>
            {projects.map((item, index) => (
              <WorkItemContainer key={index}>
                <WorkItem {...item} />
              </WorkItemContainer>
            ))}
          </Col>
        </StyledRow>
      </Container>
    </El>
  )
}

export default WorkPage

export const query = graphql`
  query WorkQuery {
    allWpPost(sort: { fields: date }) {
      edges {
        node {
          title
          slug
          portfolio_item {
            previewGallery {
              layoutKind
              images {
                videoUrl
                visualType
                image {
                  localFile {
                    childImageSharp {
                      fluid(maxWidth: 1200, quality: 75) {
                        ...GatsbyImageSharpFluid_withWebp_noBase64
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
